import { Component } from "react"
import {
    Button,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    UncontrolledDropdown
} from 'reactstrap'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import cfg from "../../../utils/config"
import auth from "../../../utils/auth"
import helper from "../../../utils/helper"
import axios from "axios"
import Table from "../../../components/Table"

class TemplateComando extends Component {
    userInfo = auth.getUserInfo()
    configMe = { headers: { 'Authorization': 'Bearer ' + auth.getToken() } }
    baseUrl = cfg.base_api_url + cfg.api_v2

    tableRef = null
    tableGlobalRef = null

    state = {
        detalhes: { descricao: "", template: "" },
        modal: { importar: false, exportar: false, salvar: false },
        jsonData: { importar: "", exportar: "" },
        tableComandos: [],
        countComandos: 0,
        nextComandos: null,
        previousComandos: null,
        loadingComandos: false,
        selected: [],
        tableGlobal: [],
        countGlobal: 0,
        nextGlobal: null,
        previousGlobal: null,
        loadingGlobal: false,
        selectedGlobal: [],
    }

    componentDidMount() {
        this.getTemplates()
    }

    fetchComandos = ({ lineCount = 10, filter = "", url = null } = {}) => {
        this.setState({ loadingComandos: true })

        const endpoint = url
            ?? `${this.baseUrl}/${this.userInfo.empresa}/comando-template/?limit=${lineCount}${filter}`

        axios.get(endpoint, this.configMe).then((res) => {
            this.setState({
                tableComandos: res.data?.results ?? [],
                countComandos: res.data?.count ?? 0,
                nextComandos: res.data?.next ?? null,
                previousComandos: res.data?.previous ?? null,
                loadingComandos: false,
            })
        }).catch(() => this.setState({ loadingComandos: false }))
    }

    fetchGlobal = ({ lineCount = 10, filter = "", url = null } = {}) => {
        this.setState({ loadingGlobal: true })

        const endpoint = url
            ?? `${this.baseUrl}/${this.userInfo.empresa}/comando-template/global/?limit=${lineCount}${filter}`

        axios.get(endpoint, this.configMe).then((res) => {
            this.setState({
                tableGlobal: res.data?.results ?? [],
                countGlobal: res.data?.count ?? 0,
                nextGlobal: res.data?.next ?? null,
                previousGlobal: res.data?.previous ?? null,
                loadingGlobal: false,
            })
        }).catch(() => this.setState({ loadingGlobal: false }))
    }

    getTemplates = () => {
        if (this.props.comandos.length > 0) {
            let { jsonData } = this.state
            let comandos = []

            this.props.comandos?.forEach(comando => {
                let configuracao = comando.configuracao
                if (typeof configuracao === "string") {
                    try {
                        configuracao = JSON.parse(configuracao)
                    } catch (err) {
                        configuracao = {}
                    }
                }

                const item = {
                    descricao: comando.descricao,
                    estrutura: comando.estrutura,
                    parametros: helper.parseComandoParametros(comando.parametros)
                }

                if (this.props.detalhes?.tipo_comunicacao === "lns_interno") {
                    item.formato = ["hex", "base64"].includes(configuracao?.formato)
                        ? configuracao.formato
                        : (comando.formato || "hex")
                    item.f_port = configuracao?.f_port ?? comando.f_port ?? 1
                    item.confirmed = configuracao?.confirmed === true || configuracao?.confirmed === "true" || comando.confirmed === true || comando.confirmed === "true"
                }

                comandos.push(item)
            })

            jsonData["exportar"] = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(comandos))
            this.setState({ jsonData })
        }

        this.fetchComandos()
        this.fetchGlobal()
    }

    handleModal = (state) => {
        let { modal } = this.state
        modal[state] = !modal[state]
        this.setState({ modal })
    }

    handleChange = (e) => {
        let { detalhes } = this.state
        detalhes[e.target.name] = e.target.value
        this.setState({ detalhes })
    }

    toggleRow = (e, id, tipo = "nuvem") => {
        if (tipo === "global") {
            this.setState({ selectedGlobal: e.target.checked ? [id] : [] })
        } else {
            this.setState({ selected: e.target.checked ? [id] : [] })
        }
    }

    saveTemplate = () => {
        const { comandos } = this.props
        const { detalhes } = this.state

        if (comandos?.length > 0) {
            if (!detalhes.descricao) return

            const body = new FormData()
            body.append("descricao", detalhes.descricao)
            body.append("template", JSON.stringify(comandos))

            axios({
                method: "POST",
                url: `${this.baseUrl}/${this.userInfo.empresa}/comando-template/`,
                data: body,
                ...this.configMe
            }).then(() => {
                let { detalhes } = this.state
                detalhes.descricao = ""
                this.setState({ detalhes })
                this.handleModal("salvar")
                helper.dispatchEvent("showAviso", { message: "Template cadastrado com sucesso" })
            })
        }
    }

    importar = async () => {
        let { detalhes, jsonData, selected, selectedGlobal } = this.state

        const createBody = (template) => {
            const body = {
                descricao: template.descricao,
                estrutura: template.estrutura,
                parametros: helper.stringifyComandoParametros(template.parametros),
                equipamento: String(this.props.detalhes.id),
            }

            if (this.props.detalhes?.tipo_comunicacao === "lns_interno") {
                let configuracao = template.configuracao
                if (typeof configuracao === "string") {
                    try {
                        configuracao = JSON.parse(configuracao)
                    } catch (err) {
                        configuracao = {}
                    }
                }

                const formato = template.formato || configuracao?.formato
                const fPort = template.f_port ?? configuracao?.f_port
                const confirmed = template.confirmed ?? configuracao?.confirmed

                const parsedFPort = parseInt(fPort ?? 1, 10)
                body.formato = ["hex", "base64"].includes(formato) ? formato : "hex"
                body.f_port = Number.isInteger(parsedFPort) && parsedFPort >= 1 ? parsedFPort : 1
                body.confirmed = confirmed === true || confirmed === "true"
            }

            return body
        }

        const postTemplates = async (templates) => {
            const requestArray = templates.map(template =>
                axios.post(
                    `${this.baseUrl}/${this.userInfo.empresa}/comando-customizado/`,
                    createBody(template),
                    { headers: { ...this.configMe.headers, 'Content-Type': 'application/json' } }
                )
            )
            if (requestArray.length > 0) {
                await axios.all(requestArray)
                this.props?.getData()
            }
        }

        if (selected.length === 1) {
            const templates = this.state.tableComandos.find(tc => tc.id === selected[0])?.template
            await postTemplates(templates ?? [])
        } else if (selectedGlobal.length === 1) {
            const templates = this.state.tableGlobal.find(tc => tc.id === selectedGlobal[0])?.template
            await postTemplates(templates ?? [])
        } else if (jsonData.importar) {
            const reader = new FileReader()
            reader.onload = async (e) => {
                try {
                    const templates = JSON.parse(e.target.result)
                    await postTemplates(templates)
                } catch (err) {
                    helper.dispatchEvent("showAviso", { message: "Erro ao processar arquivo!" })
                }
            }
            reader.readAsText(jsonData.importar)
        }

        detalhes.template = ""
        jsonData.importar = ""
        this.setState({ detalhes, jsonData, selected: [], selectedGlobal: [] })
        this.handleModal("importar")
    }

    removeTemplate = (id) => {
        axios.delete(`${this.baseUrl}/${this.userInfo.empresa}/comando-template/${id}/`, this.configMe).then(() => {
            this.fetchComandos()
            this.props?.getData()
        })
    }

    closeComando = () => {
        let { detalhes, jsonData } = this.state
        detalhes.template = ""
        jsonData.importar = ""
        this.setState({ detalhes, selected: [], selectedGlobal: [] })
        this.handleModal("importar")
    }


    getColumnsComandos = () => [
        {
            Header: "",
            Accessor: "checkbox_pessoal",
            sortable: false,
            Cell: (row) => (
                <div style={{ display: "flex", justifyContent: "center" }}>
                    <input
                        type="checkbox"
                        checked={this.state.selected?.includes(row.id)}
                        onChange={(e) => this.toggleRow(e, row.id)}
                    />
                </div>
            )
        },
        {
            Header: "Descrição",
            Accessor: "descricao",
        },
        {
            Header: "Comandos",
            Accessor: "template_count",
            sortable: false,
            Cell: (row) => row.template?.length ?? 0,
        },
        {
            Header: "",
            Accessor: "acoes",
            sortable: false,
            Cell: (row) => (
                <button
                    className="hdv-automacao-delete-button"
                    onClick={() => this.removeTemplate(row.id)}
                    style={{ borderRadius: "6px", padding: "3px 5px", color: "#333", background: "#e0e0e0" }}
                >
                    <i className="fa fa-times" style={{ fontSize: "19px" }}></i>
                </button>
            )
        }
    ]

    getColumnsGlobal = () => [
        {
            Header: "",
            Accessor: "checkbox_global",
            sortable: false,
            Cell: (row) => (
                <div style={{ display: "flex", justifyContent: "center" }}>
                    <input
                        type="checkbox"
                        checked={this.state.selectedGlobal?.includes(row.id)}
                        onChange={(e) => this.toggleRow(e, row.id, "global")}
                    />
                </div>
            )
        },
        {
            Header: "Descrição",
            Accessor: "descricao",
        },
        {
            Header: "Comandos",
            Accessor: "template_count",
            sortable: false,
            Cell: (row) => row.template?.length ?? 0,
        }
    ]

    render() {
        const { modal, jsonData, detalhes } = this.state

        return (
            <>
                <Modal isOpen={modal.importar} toggle={() => this.handleModal("importar")} className="modal-md modal-lg" data-tour="cmd-import-modal-wrap">
                    <ModalHeader toggle={() => this.handleModal("importar")}>Importar Comandos</ModalHeader>
                    <ModalBody style={{ minHeight: "380px" }} className="p-1 px-3 template-import-modal" data-tour="cmd-import-modal">
                        <Tabs>
                            <TabList data-tour="cmd-import-tabs">
                                <Tab>Pessoal</Tab>
                                <Tab>Global</Tab>
                                <Tab>Arquivo Local</Tab>
                            </TabList>
                            <TabPanel>
                                <Table
                                    notEditFirstColum
                                    checkbox={false}
                                    config={false}
                                    data={this.state.tableComandos}
                                    columns={this.getColumnsComandos()}
                                    count={this.state.countComandos}
                                    next={this.state.nextComandos}
                                    previous={this.state.previousComandos}
                                    loading={this.state.loadingComandos}
                                    onFetchData={this.fetchComandos}
                                    onUpdate={(ref) => { this.tableRef = ref }}
                                />
                            </TabPanel>
                            <TabPanel data-tour="cmd-import-checkbox-area">
                                <Table
                                    notEditFirstColum
                                    checkbox={false}
                                    config={false}
                                    data={this.state.tableGlobal}
                                    columns={this.getColumnsGlobal()}
                                    count={this.state.countGlobal}
                                    next={this.state.nextGlobal}
                                    previous={this.state.previousGlobal}
                                    loading={this.state.loadingGlobal}
                                    onFetchData={this.fetchGlobal}
                                    onUpdate={(ref) => { this.tableGlobalRef = ref }}
                                />
                            </TabPanel>
                            <TabPanel>
                                <div className="hdv-file-picker" style={{ width: "fit-content", textAlign: "center", margin: "20px auto" }}>
                                    <label>Arquivo (Formato JSON)</label>
                                    <br />
                                    <input
                                        type="file"
                                        accept=".json"
                                        name="json-file"
                                        id="json-file"
                                        value={jsonData.importar?.path ?? ""}
                                        onChange={(e) => {
                                            let { jsonData } = this.state
                                            jsonData["importar"] = e.target.files[0]
                                            this.setState({ jsonData })
                                        }}
                                    />
                                    <label style={{ width: "320px" }} htmlFor="json-file">
                                        {jsonData.importar?.name ?? "Selecionar arquivo"}
                                    </label>
                                </div>
                            </TabPanel>
                        </Tabs>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="default" data-tour="cmd-import-fechar" onClick={this.closeComando}>Fechar</Button>
                        <Button color="primary" data-tour="cmd-import-confirmar" onClick={this.importar}>Importar</Button>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={modal.salvar} toggle={() => this.handleModal("salvar")}>
                    <ModalHeader toggle={() => this.handleModal("salvar")}>Salvar Comandos</ModalHeader>
                    <ModalBody>
                        <div className="row">
                            <div className="col-md-12">
                                <label className="required" htmlFor="descricao">Descrição do template</label>
                                <input type="text" name="descricao" id="descricao" value={detalhes.descricao} onChange={this.handleChange} />
                                <span id="validacao-descricao"></span>
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="default" onClick={() => this.handleModal("salvar")}>Fechar</Button>
                        <Button color="success" onClick={this.saveTemplate}>Salvar</Button>
                    </ModalFooter>
                </Modal>

                <UncontrolledDropdown direction="right" className="float-right">
                    <DropdownToggle nav>
                        <div className="device-export-options" data-tour="cmd-options">
                            <i className="fa fa-bars" style={{ fontSize: "23px" }}></i>
                            <span>Opções</span>
                        </div>
                    </DropdownToggle>
                    <DropdownMenu className="mini-modal dropdown-menu dropdown-menu-right dropdown-params">
                        {this.props.comandos.length > 0 && (
                            <DropdownItem onClick={() => this.handleModal("salvar")}>
                                <i className="fa fa-save"></i> Salvar
                            </DropdownItem>
                        )}
                        <DropdownItem data-tour="cmd-importar" onClick={() => { this.handleModal("importar"); this.getTemplates() }}>
                            <i className="fa fa-cloud-upload-alt"></i> Importar Comandos
                        </DropdownItem>
                        {this.props.comandos.length > 0 && (
                            <a href={jsonData.exportar ?? "#"} download={`comandos_${this.props.detalhes.id ?? "0"}.json`}>
                                <DropdownItem>
                                    <i className="fa fa-cloud-download-alt"></i> Exportar Comandos
                                </DropdownItem>
                            </a>
                        )}
                    </DropdownMenu>
                </UncontrolledDropdown>
            </>
        )
    }
}

export default TemplateComando